import '../../assets/css/public-pages.css';
import { SkeletonImage } from "./MediaWithSkeleton";

const AppBannerCustom = ({appName,description,mobileImage,playStoreLink,appStoreLink}) => {
  return (
    <div className="pte-app-banner-section">
      <div className="custom-container">
        <div className="pte-app-banner">
          {/* Purple glow background */}
          <div className="pte-app-glow"></div>

          {/* Phone mockups with concentric circles */}
          <div className="pte-app-phones-wrapper">
            <SkeletonImage
              src={mobileImage}
              alt="PTE App Screenshots"
              className="pte-app-phones-img"
              aspectRatio="4/3"
            />
          </div>

          {/* Content: PTE App label + description + store badges */}
          <div className="pte-app-content">
            <div className="pte-app-info">
              <div className="pte-app-label">
                <span>{appName ? appName : 'PTE'} APP</span>
              </div>
              <p className="pte-app-description">
                Download our {description} App<br/>from App Store and Play Store
              </p>
            </div>

            <div className="pte-app-download">
              <h3 className="pte-app-download-title">Download Now!</h3>
              <div className="pte-app-store-badges">
                <a
                //   href="https://play.google.com/store/search?q=language+academy&c=apps&hl=en_IN"
                  href={playStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/web-new-images/google-play.svg"
                    loading='lazy'
                    alt="Get it on Google Play"
                    className="store-badge"
                  />
                </a>
                <a
                //   href="https://apps.apple.com/in/app/la-pte/id6443614190"
                  href={appStoreLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/images/web-new-images/app-store.svg"
                    loading='lazy'
                    alt="Download on the App Store"
                    className="store-badge"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppBannerCustom;
